namespace Gamification.Gamification {
    export interface TipologieRisorseRow {
        UserId?: number;
        TenantId?: number;
        IdTipologiaRisorsa?: number;
        Nome?: string;
        Descrizione?: string;
    }

    export namespace TipologieRisorseRow {
        export const idProperty = 'IdTipologiaRisorsa';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.TipologieRisorse';
        export const lookupKey = 'Gamification.TipologieRisorse';

        export function getLookup(): Q.Lookup<TipologieRisorseRow> {
            return Q.getLookup<TipologieRisorseRow>('Gamification.TipologieRisorse');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaRisorsa = "IdTipologiaRisorsa",
            Nome = "Nome",
            Descrizione = "Descrizione"
        }
    }
}
